module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Hersberg-8f429d2363815f20ef8b97b17a8bb5ca.svg";